import React, { useState } from 'react'
import { Card, CardBody } from 'reactstrap'
import { Radiobox } from "react-inputs-validation";


const ComponentTipoCarga = ({ value, setValue, productoSeleccionado, showOmit }) => {

    console.log('productoSeleccionado', productoSeleccionado)

    const opArr = (showOmit)
        ? [{ id: 'masiva', name: 'Masiva' }, { id: 'manual', name: 'Manual' }, { id: 'omitir', name: 'Omitir Carga' }]
        : [{ id: 'masiva', name: 'Masiva' }, { id: 'manual', name: 'Manual' }]
    ;

    const [opciones] = useState(opArr)

    return (
        <Card>
            <CardBody>

                {productoSeleccionado &&
                    <div>
                        <h4>{'Categoría: '}<strong>{productoSeleccionado.datosAp.actividad.label}</strong></h4>
                        <h5>{'Número de personas: ' + productoSeleccionado.datosAp.numeroPersonas}</h5>
                    </div>
                }

                <div style={{ marginLeft: 30, marginTop: 30 }}>

                    <Radiobox
                        disabled={false} //Optional.[Bool].Default: false.
                        value={value} //Optional.[String].Default: "".
                        validate={'validate'} //Optional.[Bool].Default: false. If you have a submit button and trying to validate all the inputs of your form at once, toggle it to true, then it will validate the field and pass the result via the "validationCallback" you provide.
                        validationCallback={(res) => {
                            console.log(res)
                        }
                            // this.setState({ hasJobError: res, validate: false })
                        } //Optional.[Func].Default: none. Return the validation result.
                        optionList={opciones}
                        classNameInput="" //Optional.[String].Default: "".
                        classNameWrapper="" //Optional.[String].Default: "".
                        classNameContainer="" //Optional.[String].Default: "".
                        classNameOptionListItem="" //Optional.[String].Default: "".
                        customStyleInput={{}} //Optional.[Object].Default: {}.
                        customStyleWrapper={{}} //Optional.[Object].Default: {}.
                        customStyleContainer={{
                            display: 'flex',
                            justifyContent: 'flex-start'
                        }} //Optional.[Object].Default: {}.
                        customStyleOptionListItem={{ marginRight: '20px' }} //Optional.[Object].Default: {}.
                        onChange={(valor, e) => {
                            setValue(valor)
                        }} //Required.[Func].Default: () => {}. Will return the value.
                        onBlur={(e) => { console.log(e) }} //Optional.[Func].Default: none.
                        validationOption={{
                            name: 'Name', //Optional.[String].Default: "". To display in the Error message. i.e Please enter your ${name}.
                            check: true, //Optional.[Bool].Default: true. To determin if you need to validate.
                            required: true, //Optional.[Bool].Default: true. To determin if it is a required field.
                        }}
                    />
                </div>
            </CardBody>
        </Card>
    )

}

export default ComponentTipoCarga